<template>
  <section id="footer">
    <footer>
      <div class="container">
        <div class="row footer-wrapper">
          <div class="col-12 col-md-12 col-lg-5 mb-3">
            <router-link to="/" class="d-flex align-items-center">
              <img :src="arkLogo" alt="" /><span class="footer-link-head"
                >Health<span class="ark">Ark</span></span
              >
            </router-link>
            <p class="footer-content-1">
              King’s deck, alternative route, off chevron drive, Lekki-Epe
              expressway, Lagos
            </p>
            <p class="footer-content-1">Call us: +234 701 409 6513</p>
            <p class="footer-content-1">Email us: healtharkng@gmail.com</p>

            <div class="social-media-container">
              <a href="#" class="twitter">
                <i class="bi bi-twitter"></i>
              </a>
              <a href="#" class="facebook">
                <i class="bi bi-facebook"></i>
              </a>
              <a href="#" class="linkedin">
                <i class="bi bi-linkedin"></i>
              </a>
              <a href="#" class="instagram">
                <i class="bi bi-instagram"></i>
              </a>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-4 mb-3">
            <div class="row">
              <div class="col-6">
                <p class="tour">Takeatour</p>
                <ul class="footer-list">
                  <li><a href="">Products</a></li>
                  <li><a href="">Pricing</a></li>
                  <li><a href="">Support</a></li>
                </ul>
              </div>
              <div class="col-6">
                <p class="company">Our Company</p>
                <ul class="footer-list">
                  <li><a href="">About Us</a></li>
                  <li><a href="">Contact Us</a></li>
                  <li><a href="">Blog</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-3 mb-3">
            <p class="subscribe">Subscribe</p>
            <p>Subscribe to get the latest news from us</p>
            <div class="mb-3 subscribe-form">
              <input
                type="email"
                class="form-control shadow-none subscribe-input"
                placeholder="Email Address"
              />
              <img :src="subscribe" alt="" class="subscribe-img" />
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="col-md-12 footer-bottom">
      <p>
        Copyright {{ currentYear }} &copy;
        <a href="mailto:">The Ark Team</a>
      </p>
    </div>
  </section>
</template>

<script>
import ref from "vue";
export default {
  name: "Footer",
  setup() {
    const arkLogo = "/img/Ark_Logo-sm-footer.png";
    const subscribe = "/img/subscribe.png";
    const date = new Date();
    const currentYear = date.getFullYear();

    return {
      arkLogo,
      subscribe,
      currentYear,
    };
  },
};
</script>

<style scoped>
* {
  text-decoration: none !important;
  list-style-type: none !important;
}
footer {
  background-color: var(--Ghost-White);
  padding: 100px 0 60px 0;
  font-family: var(--ff-openSans);
  color: var(--Outer-Space) !important;
}
@media screen and (max-width: 767px) {
  .footer-wrapper {
    flex-direction: column-reverse;
  }
}
.footer-link-head {
  font-weight: 700;
  font-family: var(--ff-openSans);
  font-size: var(--fs-20);
  color: var(--Outer-Space);
}
.ark {
  color: var(--Sky-Blue);
}
.footer-content-1 {
  margin-top: 16px;
  font-family: var(--ff-openSans);
}
.social-media-container > a {
  color: var(--Cerulean);
}
.social-media-container > a:not(.twitter) {
  margin-left: 32px;
}
.bi {
  font-size: 22px;
}

.tour,
.company,
.subscribe {
  font-weight: 700;
  font-family: var(--ff-openSans);
  font-size: var(--fs-20);
  color: var(--Outer-Space);
}
.footer-list {
  padding: 0;
}
.footer-list > li:not(:first-child) {
  margin-top: 16px;
}
.footer-list > li > a {
  color: var(--Outer-Space);
  font-weight: var(--fw-400);
}
.subscribe-form {
  position: relative;
}
.subscribe-input {
  border-radius: 8px 8px 0px 0px;
  padding: 12px 60px 11px 16px;
  border: none;
  border-bottom: 2px solid #454545;
  outline: none !important;
}
.subscribe-img {
  position: absolute;
  top: 12px;
  right: 6px;
  transform: translate(-50%);
  cursor: pointer;
}

.footer-bottom {
  background-color: var(--Cerulean);
  padding: 40px 0;
}
.footer-bottom > p {
  text-align: center;
  color: #fff;
  font-family: var(--ff-openSans);
}
.footer-bottom > p > a {
  color: #fff;
  font-family: var(--ff-openSans);
}
</style>
